import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

// ==== GENERATOR ====
// Wersja z ujemnym ilorazem q.

function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function randomA1() {
  // a1 z przedziału -9..-2 ∪ 2..9 (bez -1, 0, 1)
  const candidates = [];
  for (let x = -9; x <= 9; x++) {
    if (Math.abs(x) >= 2 && Math.abs(x) <= 9) {
      candidates.push(x);
    }
  }
  const idx = Math.floor(Math.random() * candidates.length);
  return candidates[idx];
}

export function generateTask() {
  const a1 = randomA1();

  // q ujemne całkowite od -7 do -2
  const q = -randomInt(2, 7);

  // liczba wyrazów 3..6
  const n = randomInt(3, 6);

  const sum =
    q === 1
      ? a1 * n
      : (a1 * (1 - Math.pow(q, n))) / (1 - q);

  return {
    type: "FindSumGeoNegQTask",
    data: { a1, q, n, sum }
  };
}

// ==== RENDER ====

export function renderTask({ data }) {
  const { a1, q, n } = data;

  return (
    <>
      <p>
        Dany jest ciąg geometryczny, w którym{" "}
        <InlineMath math={`a_1 = ${a1}`} />,{" "}
        <InlineMath math={`q = ${q}`} />.
      </p>
      <p>
        Oblicz sumę pierwszych <InlineMath math={`${n}`} /> wyrazów tego ciągu.
      </p>
    </>
  );
}

export function renderInput(task, userAnswer, onChange, disabled) {
  const n = task?.data?.n;
  const label = n ? `S_{${n}}` : "S_n";

  const handleChange = (val) => {
    if (typeof onChange === "function") {
      onChange({ ...val, label });
    }
  };

  return (
    <div className="flex items-center gap-2">
      <InlineMath math={`${label} =`} />
      <FractionInput
        value={userAnswer}
        onChange={handleChange}
        disabled={disabled}
        label={label}
      />
    </div>
  );
}

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const given = userAnswer.parsed;
  if (given === null) return false;

  return Math.abs(given - data.sum) < 0.01;
}

export function renderAnswer({ data }) {
  return <InlineMath math={`S_{${data.n}} = ${data.sum}`} />;
}

export function renderExplanation({ data }) {
  const { a1, q, n, sum } = data;

  const qn = Math.pow(q, n);
  const denominator = 1 - q;
  const numerator = 1 - qn;
  const fracValue = numerator / denominator;

  return (
    <div className="space-y-2">
      <p>
        <strong>Krok 1:</strong> Wzór na sumę pierwszych{" "}
        <InlineMath math="n" /> wyrazów ciągu geometrycznego (dla{" "}
        <InlineMath math={"q \\neq 1"} />):
      </p>
      <BlockMath math={"S_n = a_1 \\cdot \\frac{1 - q^n}{1 - q}"} />

      <p>
        <strong>Krok 2:</strong> Podstawiamy dane.
      </p>
      <BlockMath
        math={`S_{${n}} = ${a1} \\cdot \\frac{1 - (${q})^{${n}}}{1 - (${q})}`}
      />
      <BlockMath
        math={`S_{${n}} = ${a1} \\cdot \\frac{1 - ${qn}}{${denominator}}`}
      />

      <p>
        <strong>Krok 3:</strong> Obliczamy wartość ułamka, a następnie
        mnożymy przez <InlineMath math="a_1" />.
      </p>
      <BlockMath math={`S_{${n}} = ${a1} \\cdot ${fracValue}`} />
      <BlockMath math={`S_{${n}} = ${sum}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer /*, task */) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }

  const label = userAnswer.label || "S_n";

  return <InlineMath math={`${label} = ${userAnswer.raw}`} />;
}
